module.exports = __webpack_public_path__ + "media/images/full_width_add_photo-adfe0d7146b248e61129edd1e0da67b1.png";